<div>
    <div *ngIf="!_loading; else templateLoadingCalendarConfig">
        <div *ngIf="!_data; else templateProviderRegistered" class="text-center">
            <p>App is not registered.</p>
            <p>Please register it from the 'Registration' page first.</p>
        </div>
        <ng-template #templateProviderRegistered>
            <div class="mx-2">Customize the look & feel</div>
            <div class="content">
                <div class="data-block">
                    <h5>General settings</h5>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group row">
                                <label for="col-ge-pin" class="col-12 col-md-4 col-form-label">
                                    PIN
                                </label>
                                <div class="col-12 col-md-8">
                                    <input id="col-ge-pin" type="text" class="form-control form-control-sm"
                                        minlength="4" maxlength="4" [class.changed]="_data.pin.isChanged"
                                        [disabled]="_updating" [(ngModel)]="_data.pin.current">
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group row">
                                <label for="ch-fontsize" class="col-12 col-md-4 col-form-label">
                                    Font size
                                </label>
                                <div class="col-12 col-md-8">
                                    <div id="ctrl-fontsize-options" class="d-flex form-control form-control-sm"
                                        [class.changed]="_data.fontsizeRatio.isChanged">
                                        <div *ngFor="let fs of _fontsizeOptionList" class="cmn-radio mx-2">
                                            <input [id]="fs.id" type="radio" name="fontsizeOption"
                                                [checked]="fs.ratio === _data.fontsizeRatio.current"
                                                [disabled]="_updating" (click)="_data.fontsizeRatio.current = fs.ratio">
                                            <label [for]="fs.id" class="radio"></label>
                                            <span class="ml-2">{{ fs.displayName }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row mt-2">
                                <div class="col-12 col-lg-6">
                                    <na-customization-item-img [title]="'Logo'" [fileFormat]="['png', 'svg']"
                                        [disabled]="_updating" [data]="_data.logo" [maxAllowSize]="0.5"
                                        (onItemChanged)="onLogoImageChanged($event)">
                                    </na-customization-item-img>
                                </div>
                                <div class="col-12 col-lg-6 mt-2 mt-lg-0">
                                    <na-customization-item-img [title]="'Background image'"
                                        [fileFormat]="['png', 'svg']" [data]="_data.background" [maxAllowSize]="4"
                                        [disabled]="_updating" (onItemChanged)="onBackgroundImageChanged($event)">
                                    </na-customization-item-img>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="data-block">
                    <h5>Meeting room options</h5>
                    <div class="row">
                        <div class="col-12">
                            <fieldset>
                                <legend>On-site booking</legend>
                                <div class="flex-wrap-group">
                                    <div class="col-12 d-flex align-items-center">
                                        <input id="ch-ge-onsite-book" type="checkbox" class="cmn-checkbox"
                                            [class.changed]="_data.calendar.enableOnsiteBook.isChanged"
                                            [disabled]="_updating"
                                            [(ngModel)]="_data.calendar.enableOnsiteBook.current" />
                                        <label for="ch-ge-onsite-book">
                                            <svg>
                                                <use xlink:href="#checkmark" />
                                            </svg>
                                        </label>
                                        <div class="ml-2">On-site booking. Display reserved by username as</div>
                                        <div class="form-group mb-0">
                                            <input id="col-ge-onsite-book-username" type="text"
                                                class="form-control form-control-sm ml-2"
                                                [class.changed]="_data.calendar.reservedDisplayNameForOnSiteBook.isChanged"
                                                [disabled]="_updating"
                                                [(ngModel)]="_data.calendar.reservedDisplayNameForOnSiteBook.current">
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12 d-flex align-items-center">
                                        <input id="ch-ge-onsite-meeting-name" type="checkbox" class="cmn-checkbox"
                                            [class.changed]="_data.calendar.showEventSubject.isChanged"
                                            [disabled]="_updating"
                                            [(ngModel)]="_data.calendar.showEventSubject.current" />
                                        <label for="ch-ge-onsite-meeting-name">
                                            <svg>
                                                <use xlink:href="#checkmark" />
                                            </svg>
                                        </label>
                                        <span class="ml-2">Show meeting name</span>
                                    </div>
                                    <div class="col-md-6 col-12 d-flex align-items-center">
                                        <input id="ch-ge-onsite-cancel" type="checkbox" class="cmn-checkbox"
                                            [class.changed]="_data.calendar.enableOnsiteCancelOrStop.isChanged"
                                            [disabled]="_updating"
                                            [(ngModel)]="_data.calendar.enableOnsiteCancelOrStop.current" />
                                        <label for="ch-ge-onsite-cancel">
                                            <svg>
                                                <use xlink:href="#checkmark" />
                                            </svg>
                                        </label>
                                        <span class="ml-2">Allow users to cancel on-site bookings</span>
                                    </div>
                                    <div class="col-md-6 col-12 d-flex align-items-center">
                                        <input id="ch-ge-onsite-extend" type="checkbox" class="cmn-checkbox"
                                            [class.changed]="_data.calendar.enableOnsiteExtend.isChanged"
                                            [disabled]="_updating"
                                            [(ngModel)]="_data.calendar.enableOnsiteExtend.current" />
                                        <label for="ch-ge-onsite-extend">
                                            <svg>
                                                <use xlink:href="#checkmark" />
                                            </svg>
                                        </label>
                                        <span class="ml-2">Allow users to extend on-site booking</span>
                                    </div>
                                    <div class="col-md-6 col-12 d-flex align-items-center">
                                        <input id="ch-ge-onsite-autoCheckin" type="checkbox" class="cmn-checkbox"
                                            [class.changed]="_data.calendar.enableOnsiteAutoCheckin.isChanged"
                                            [disabled]="_updating"
                                            [(ngModel)]="_data.calendar.enableOnsiteAutoCheckin.current" />
                                        <label for="ch-ge-onsite-autoCheckin">
                                            <svg>
                                                <use xlink:href="#checkmark" />
                                            </svg>
                                        </label>
                                        <span class="ml-2">Allow automatic check-in for on-site bookings</span>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="d-flex align-items-center">
                                            <input id="ch-ge-userlist" type="checkbox" class="cmn-checkbox"
                                                [class.changed]="_data.calendar.enableUserList.isChanged"
                                                [disabled]="_updating"
                                                [(ngModel)]="_data.calendar.enableUserList.current" />
                                            <label for="ch-ge-userlist">
                                                <svg>
                                                    <use xlink:href="#checkmark" />
                                                </svg>
                                            </label>
                                            <span class="ml-2">Show user list to on-site user</span>
                                        </div>
                                        <div>
                                            <div id="ctrl-userlist-options" class="form-control h-auto"
                                                [class.changed]="_data.calendar.userDisplayOption.isChanged">
                                                <div *ngFor="let option of _userDisplayOptionList"
                                                    class="cmn-radio mx-2">
                                                    <input [id]="option" type="radio" name="userDisplayOption"
                                                        [checked]="option === _data.calendar.userDisplayOption.current"
                                                        [disabled]="_updating || !_data.calendar.enableUserList.current"
                                                        (click)="_data.calendar.userDisplayOption.current = option">
                                                    <label [for]="option" class="radio"></label>
                                                    <span [ngSwitch]="option" class="ml-2">
                                                        <span *ngSwitchCase="UserDisplayOption.USER_NAME">Display
                                                            user
                                                            name</span>
                                                        <span *ngSwitchCase="UserDisplayOption.USER_ID">Display
                                                            user
                                                            id</span>
                                                        <span *ngSwitchCase="UserDisplayOption.ALL">Display user
                                                            id
                                                            and user name</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>On-site daily timeline</legend>
                                <div class="flex-wrap-group">
                                    <div class="col-md-6 col-12 d-flex align-items-center">
                                        <input id="ch-timeline-enable" type="checkbox" class="cmn-checkbox"
                                            [class.changed]="_data.calendar.showTimeline.isChanged"
                                            [disabled]="_updating" [(ngModel)]="_data.calendar.showTimeline.current" />
                                        <label for="ch-timeline-enable">
                                            <svg>
                                                <use xlink:href="#checkmark" />
                                            </svg>
                                        </label>
                                        <span class="ml-2">Show daily timeline</span>
                                    </div>
                                    <div class="col-md-6 col-12 d-flex align-items-center">
                                        <input id="ch-ge-future-book" type="checkbox" class="cmn-checkbox"
                                            [class.changed]="_data.calendar.enableFutureEventBook.isChanged"
                                            [disabled]="_updating"
                                            [(ngModel)]="_data.calendar.enableFutureEventBook.current" />
                                        <label for="ch-ge-future-book">
                                            <svg>
                                                <use xlink:href="#checkmark" />
                                            </svg>
                                        </label>
                                        <span class="ml-2">Allow booking from the daily timeline</span>
                                    </div>
                                    <div class="col-md-6 col-12 d-flex align-items-center">
                                        <input id="ch-ge-future-cancel" type="checkbox" class="cmn-checkbox"
                                            [class.changed]="_data.calendar.enableFutureEventCancel.isChanged"
                                            [disabled]="_updating"
                                            [(ngModel)]="_data.calendar.enableFutureEventCancel.current" />
                                        <label for="ch-ge-future-cancel">
                                            <svg>
                                                <use xlink:href="#checkmark" />
                                            </svg>
                                        </label>
                                        <span class="ml-2">Allow cancellation from the daily timeline</span>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>Main content color</legend>
                                <div class="flex-wrap-group">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group row">
                                            <label for="col-main-fg" class="col-12 col-form-label">
                                                Foreground
                                            </label>
                                            <div class="col-12">
                                                <input id="col-main-fg" type="color"
                                                    class="form-control form-control-sm"
                                                    [class.changed]="_data.theme.foreground.isChanged"
                                                    [disabled]="_updating" [(ngModel)]="_data.theme.foreground.current">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group row">
                                            <label for="col-main-free" class="col-12 col-form-label">
                                                Available
                                            </label>
                                            <div class="col-12">
                                                <na-colorPicker [color]="_data.theme.availableColor.current"
                                                    [isChanged]="_data.theme.availableColor.isChanged"
                                                    [disabled]="_updating"
                                                    (onColorChanged)="_data.theme.availableColor.current = $event">
                                                </na-colorPicker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group row">
                                            <label for="col-main-inuse" class="col-12 col-form-label">
                                                Occupied
                                            </label>
                                            <div class="col-12">
                                                <na-colorPicker [color]="_data.theme.busyColor.current"
                                                    [isChanged]="_data.theme.busyColor.isChanged" [disabled]="_updating"
                                                    (onColorChanged)="_data.theme.busyColor.current = $event">
                                                </na-colorPicker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>Timeline color</legend>
                                <div class="flex-wrap-group">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group row">
                                            <label for="col-timeline-bg" class="col-12 col-form-label">
                                                Background
                                            </label>
                                            <div class="col-12">
                                                <input id="col-timeline-bg" type="color"
                                                    class="form-control form-control-sm"
                                                    [class.changed]="_data.theme.timeline.bgColor.isChanged"
                                                    [disabled]="_updating"
                                                    [(ngModel)]="_data.theme.timeline.bgColor.current">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group row">
                                            <label for="col-timeline-future" class="col-12 col-form-label">
                                                Future event
                                            </label>
                                            <div class="col-12">
                                                <na-colorPicker
                                                    [color]="_data.theme.timeline.futureEventTimeBlockColor.current"
                                                    [isChanged]="_data.theme.timeline.futureEventTimeBlockColor.isChanged"
                                                    [disabled]="_updating"
                                                    (onColorChanged)="_data.theme.timeline.futureEventTimeBlockColor.current = $event">
                                                </na-colorPicker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group row">
                                            <label for="col-timeline-current" class="col-12 col-form-label">
                                                Current event
                                            </label>
                                            <div class="col-12">
                                                <na-colorPicker
                                                    [color]="_data.theme.timeline.currentEventTimeBlockColor.current"
                                                    [isChanged]="_data.theme.timeline.currentEventTimeBlockColor.isChanged"
                                                    [disabled]="_updating"
                                                    (onColorChanged)="_data.theme.timeline.currentEventTimeBlockColor.current = $event">
                                                </na-colorPicker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group row">
                                            <label for="col-timeline-expire" class="col-12 col-form-label">
                                                Expired event
                                            </label>
                                            <div class="col-12">
                                                <na-colorPicker
                                                    [color]="_data.theme.timeline.expiredEventTimeBlockColor.current"
                                                    [isChanged]="_data.theme.timeline.expiredEventTimeBlockColor.isChanged"
                                                    [disabled]="_updating"
                                                    (onColorChanged)="_data.theme.timeline.expiredEventTimeBlockColor.current = $event">
                                                </na-colorPicker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
                <div class="data-block">
                    <h5>Desk office options</h5>
                    <div class="row">
                        <div class="col-12 d-flex align-items-center">
                            <div>Upcoming availability window</div>
                            <div class="form-group mx-2 mb-0">
                                <input id="col-ge-onsite-book-username" type="number" min="10" max="60"
                                    class="form-control form-control-sm"
                                    [class.changed]="_data.deskOffice.upcomingAvailabilityWindow.isChanged"
                                    [disabled]="_updating"
                                    [(ngModel)]="_data.deskOffice.upcomingAvailabilityWindow.current">
                            </div>
                            <div>minutes</div>
                        </div>
                    </div>
                    <fieldset>
                        <legend>On-site booking</legend>
                        <div class="flex-wrap-group">
                            <div class="col-12 d-flex align-items-center">
                                <input id="ch-desk-onsite-book" type="checkbox" class="cmn-checkbox"
                                    [class.changed]="_data.deskOffice.enableOnsiteBook.isChanged" [disabled]="_updating"
                                    [(ngModel)]="_data.deskOffice.enableOnsiteBook.current" />
                                <label for="ch-desk-onsite-book">
                                    <svg>
                                        <use xlink:href="#checkmark" />
                                    </svg>
                                </label>
                                <div class="ml-2">On-site booking. Display reserved by username as</div>
                                <div class="form-group mb-0">
                                    <input id="col-ge-onsite-book-username" type="text"
                                        class="form-control form-control-sm ml-2"
                                        [class.changed]="_data.deskOffice.reservedDisplayNameForOnSiteBook.isChanged"
                                        [disabled]="_updating"
                                        [(ngModel)]="_data.deskOffice.reservedDisplayNameForOnSiteBook.current">
                                </div>
                            </div>
                            <div class="col-md-6 col-12 d-flex align-items-center">
                                <input id="ch-desk-onsite-cancel" type="checkbox" class="cmn-checkbox"
                                    [class.changed]="_data.deskOffice.enableOnsiteCancelOrStop.isChanged"
                                    [disabled]="_updating"
                                    [(ngModel)]="_data.deskOffice.enableOnsiteCancelOrStop.current" />
                                <label for="ch-desk-onsite-cancel">
                                    <svg>
                                        <use xlink:href="#checkmark" />
                                    </svg>
                                </label>
                                <span class="ml-2">Allow users to cancel on-site bookings</span>
                            </div>
                            <div class="col-md-6 col-12 d-flex align-items-center">
                                <input id="ch-desk-onsite-autoCheckin" type="checkbox" class="cmn-checkbox"
                                    [class.changed]="_data.deskOffice.enableOnsiteAutoCheckin.isChanged"
                                    [disabled]="_updating"
                                    [(ngModel)]="_data.deskOffice.enableOnsiteAutoCheckin.current" />
                                <label for="ch-desk-onsite-autoCheckin">
                                    <svg>
                                        <use xlink:href="#checkmark" />
                                    </svg>
                                </label>
                                <span class="ml-2">Allow automatic check-in for on-site bookings</span>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>Desk color</legend>
                        <div class="flex-wrap-group">
                            <div class="col-12 col-md-4">
                                <div class="form-group row">
                                    <label for="col-desk-color-fg" class="col-12 col-form-label">
                                        Foreground
                                    </label>
                                    <div class="col-12">
                                        <input id="col-desk-color-fg" type="color" class="form-control form-control-sm"
                                            [class.changed]="_data.deskOffice.theme.foreground.isChanged"
                                            [disabled]="_updating"
                                            [(ngModel)]="_data.deskOffice.theme.foreground.current">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form-group row">
                                    <label for="col-desk-color-available" class="col-12 col-form-label">
                                        Available
                                    </label>
                                    <div class="col-12">
                                        <na-colorPicker [color]="_data.deskOffice.theme.availableColor.current"
                                            [isChanged]="_data.deskOffice.theme.availableColor.isChanged"
                                            [disabled]="_updating"
                                            (onColorChanged)="_data.deskOffice.theme.availableColor.current = $event">
                                        </na-colorPicker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form-group row">
                                    <label for="col-desk-color-inuse" class="col-12 col-form-label">
                                        Occupied
                                    </label>
                                    <div class="col-12">
                                        <na-colorPicker [color]="_data.deskOffice.theme.busyColor.current"
                                            [isChanged]="_data.deskOffice.theme.busyColor.isChanged"
                                            [disabled]="_updating"
                                            (onColorChanged)="_data.deskOffice.theme.busyColor.current = $event">
                                        </na-colorPicker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group row">
                                    <label for="col-desk-border-weight" class="col-12 col-md-4 col-form-label">
                                        Border line weight
                                    </label>
                                    <div class="col-12 col-md-8">
                                        <input id="col-desk-border-weight" type="number" min="1" max="5"
                                            class="form-control form-control-sm"
                                            [class.changed]="_data.deskOffice.theme.borderLineWeight.isChanged"
                                            [disabled]="_updating"
                                            [(ngModel)]="_data.deskOffice.theme.borderLineWeight.current">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="data-block">
                    <h5>Lightbar color</h5>
                    <div class="row">
                        <div class="col-12 d-flex align-items-center">
                            <input id="ch-lightbar-activate" type="checkbox" class="cmn-checkbox"
                                [class.changed]="_data.lightbar.activate.isChanged" [disabled]="_updating"
                                [(ngModel)]="_data.lightbar.activate.current" />
                            <label for="ch-lightbar-activate">
                                <svg>
                                    <use xlink:href="#checkmark" />
                                </svg>
                            </label>
                            <span class="ml-2">Activate</span>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group row">
                                <label for="col-lightbar-free" class="col-12 col-form-label">
                                    Available
                                </label>
                                <div class="col-12">
                                    <input id="col-lightbar-free" type="color" class="form-control form-control-sm"
                                        [class.changed]="_data.lightbar.available.color.isChanged"
                                        [disabled]="_updating || !_data.lightbar.activate.current"
                                        [(ngModel)]="_data.lightbar.available.color.current">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group row">
                                <label for="col-lightbar-inuse" class="col-12 col-form-label">
                                    InUse
                                </label>
                                <div class="col-12">
                                    <input id="col-lightbar-inuse" type="color" class="form-control form-control-sm"
                                        [class.changed]="_data.lightbar.busy.color.isChanged"
                                        [disabled]="_updating || !_data.lightbar.activate.current"
                                        [(ngModel)]="_data.lightbar.busy.color.current">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group row">
                                <label for="col-lightbar-brightness" class="col-12 col-form-label">
                                    Brightness
                                </label>
                                <div class="col-12">
                                    <input id="col-lightbar-brightness" type="number" min="0" max="100" class="form-control form-control-sm"
                                        [class.changed]="_data.lightbar.brightness.isChanged"
                                        [disabled]="_updating || !_data.lightbar.activate.current"
                                        [(ngModel)]="_data.lightbar.brightness.current">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4 text-center">
                <div *ngIf="_errorMessage" class="my-2">{{ _errorMessage }}</div>
                <div *ngIf="_data" class="d-flex align-items-center justify-content-center">
                    <button type="button" class="btn btn-sm btn-action btn-light" [disabled]="_updating"
                        (click)="resetCalendarInfo()">
                        <i class="fas fa-times mr-1"></i>
                        Reset
                    </button>
                    <button type="button" class="btn btn-sm btn-action btn-ligth ml-2"
                        [disabled]="_updating || !_data?.isValid() || !_data.isChanged()"
                        (click)="updateCalendarInfo()">
                        <i class="fas fa-check mr-1"></i>
                        Update
                    </button>
                    <div *ngIf="_updating" class="loading loading-p0 ml-4">
                        <div class="loading-box"></div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
    <ng-template #templateLoadingCalendarConfig>
        <div class="loading">
            <p>Please wait...</p>
            <div class="loading-box"></div>
        </div>
    </ng-template>
</div>